// extracted by mini-css-extract-plugin
module.exports = {"root":"Paper_root__2ER9K"};